import React, { useState } from "react"
import Presentation from "./Presentation"
export default function Container(props) {
  return (
    <div>
      <Presentation {...props} />
    </div>
  )
}
